import Vue from 'vue'
import VueRouter from "vue-router";
import {routes} from './routes';
import Vuex from "vuex";
import storeData from "@/store/store";

Vue.use(VueRouter);
Vue.use(Vuex);
const store = new Vuex.Store(storeData);

let router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.fullPath === from.fullPath) {
        return next();
    }
    store.dispatch('tryLogin').then(function () {
        //console.log('verifico rutas');
        if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
            next("/login");
        } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
            next("/home");
        } else if (to.meta.requiresAuth && to.meta.requiresActive && !store.getters.isActive) {
            next("/validate");
        } else if (to.meta.requiresAuth && to.meta.requiresInactive && store.getters.isActive) {
            next("/home");
        } else {
            //console.info('auth-router-index', store.getters.isAuthenticated);
            next();
        }
    });
});

export {store};
export {router};
